export default {
	1: 'Tumblr'
};
